// Fan-uploaded "Team Kit" images for the Lineup Builder / Classic Lineup
// Builder — read entirely client-side (FileReader -> data URL), never
// uploaded to the backend, never sent as part of a shared lineup.
export const MAX_SHIRT_UPLOAD_BYTES = 3 * 1024 * 1024;
const ALLOWED_SHIRT_TYPES = ["image/jpeg", "image/png", "image/webp"];

export function readShirtImageFile(file) {
  return new Promise((resolve, reject) => {
    if (!ALLOWED_SHIRT_TYPES.includes(file.type)) {
      reject(new Error("Please upload a JPG, PNG or WEBP image."));
      return;
    }
    if (file.size > MAX_SHIRT_UPLOAD_BYTES) {
      reject(new Error("Image must be 3MB or smaller."));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Couldn't read that image — please try again."));
    reader.readAsDataURL(file);
  });
}
